var _excluded = ["children", "enter", "from", "leave"];

var _jsxFileName = "/Users/krise/gitlab/drywall/src/components/AnimatedList/AnimatedList.jsx",
    _this = this;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { animated, Transition } from 'react-spring/renderprops.cjs';
var Item = styled(animated.li).withConfig({
  displayName: "AnimatedList__Item",
  componentId: "sc-sdziqv-0"
})([""]);
/**
 * An `AnimatedList` provides a default animation for addition and removal of items in a list.
 * The animation is provided by the [react-spring](https://www.react-spring.io/) library.
 *
 * ##### Browser Support
 * react-spring [requires polyfills](https://github.com/vai0/react-spring/blob/f579b20709/documentation/Gotchas.mdx#browser-support)
 * for Internet Explorer -- if those polyfills are not detected, the list will not animate.
 */

var AnimatedList = styled(function (_ref) {
  var children = _ref.children,
      enter = _ref.enter,
      from = _ref.from,
      leave = _ref.leave,
      rest = _objectWithoutProperties(_ref, _excluded);

  // feature detect for react-spring compatability, otherwise render static items
  var content;

  if (Object.entries) {
    content = /*#__PURE__*/React.createElement(Transition, {
      native: true,
      keys: function keys(child) {
        return child.key || child;
      },
      items: children,
      from: from,
      enter: enter,
      leave: leave,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 13
      }
    }, function (child) {
      return function (style) {
        return /*#__PURE__*/React.createElement(Item, {
          style: style,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 29,
            columnNumber: 36
          }
        }, child);
      };
    });
  } else {
    content = React.Children.map(children, function (child) {
      return /*#__PURE__*/React.createElement(Item, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 33,
          columnNumber: 57
        }
      }, child);
    });
  }

  return /*#__PURE__*/React.createElement("ul", _extends({}, rest, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 12
    }
  }), content);
}).withConfig({
  displayName: "AnimatedList",
  componentId: "sc-sdziqv-1"
})([""]);
AnimatedList.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A dynamic list of items. Each item will be wrapped by an `<AnimatedList.Item>` component.
   * By default, the content of each item will be used as the key. For non-trivial lists, you will
   * want to add a `key` attribute to each item.
   */
  children: PropTypes.node,

  /**
   * The react-spring [`Transition`](https://www.react-spring.io/docs/props/transition) `enter` prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  enter: PropTypes.any,

  /**
   * The react-spring [`Transition`](https://www.react-spring.io/docs/props/transition) `from` prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  from: PropTypes.any,

  /**
   * The react-spring [`Transition`](https://www.react-spring.io/docs/props/transition) `leave` prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  leave: PropTypes.any
} : {};
AnimatedList.defaultProps = {
  enter: {
    opacity: 1,
    height: 'auto'
  },
  from: {
    opacity: 0,
    height: 0
  },
  leave: {
    opacity: 0,
    height: 0
  }
};
AnimatedList.Item = Item;
/** @component */

export default AnimatedList;